<template>
  <div class="content">
    <div class="rotation">
      <div class="rotation_content">
        <ul class="relation_ul">
          <el-form ref="formList" :rules="rules" :model="detailList" :inline="true" label-width="150px">
            <li  class="relation_li">
              <div class="el_item_div">
                <el-form-item label="课程名称：" >
                  <p class="relation_title">
                    <span class='r_title'> {{detailList.sequence}}：{{detailList.module_name}}</span>
                  </p>
                </el-form-item>
              </div>
              <div class="el_item_div">
                <el-form-item label="管理码："  class="code_item">
                  <span> {{detailList.admin_code}}</span>
                </el-form-item>
                <el-form-item label="老师码："  class="code_item">
                  <span> {{detailList.teacher_code}}</span>
                </el-form-item>
                <el-form-item label="学生码："  class="code_item">
                  <span> {{detailList.student_code}}</span>
                </el-form-item>
              </div>
              <div class="el_item_div">
                <el-form-item label="类型：" prop="type" class="all_width">
                  <el-select v-model="detailList.type" placeholder="请选择类型" class="all_width" disabled="disabled">
                    <el-option
                      v-for="item in typeArr"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="el_item_div">
                <el-form-item label="上课日期：" prop="date" class="all_width">
                  <el-date-picker
                    v-model="detailList.date"
                    type="date"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    placeholder="选择上课时间">
                  </el-date-picker>
                </el-form-item>
              </div>
              <div class="el_item_div">
                <el-form-item label="具体时间：" prop="begin_time" class="all_width">
                  <el-time-picker
                    is-range
                    v-model="timeArr"
                    format="HH:mm"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    @change="changeTime"
                    placeholder="选择时间范围">
                  </el-time-picker>
                </el-form-item>
              </div>
              <div class="el_item_div">
                <el-form-item label="上课老师：" prop="teacher_id" class="all_width">
                  <el-select v-model="detailList.teacher_id" filterable placeholder="请选择上课老师" class="all_width">
                    <el-option
                      v-for="item in teacherList"
                      :key="item.id"
                      :label="item.realname"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="el_item_div" v-if="detailList.type === 2">
                <el-form-item label="最大人数：" class="all_width" type="number">
                  <el-input v-model="detailList.max_users"></el-input>
                </el-form-item>
              </div>
              <div class="el_item_div">
                <el-form-item label="学生提前进入时间 ：" class="all_width">
                  <el-input v-model="detailList.pre_enter_time" type="number" >
                    <template slot="append">分钟</template>
                  </el-input>
                </el-form-item>
              </div>
            </li>
            <el-form-item class="relation_btn">
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>
        </ul>    
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'relationClass',
  components:{
  },
  data(){
    return {
      rules:{
        teacher_id :[{required: true, message: '请选择老师', trigger: 'change'}],
        date :[{required: true, message: '请选择上课日期', trigger: 'change'}],
        begin_time :[{required: true, message: '请选择上课时间', trigger: 'change'}],
        end_time :[{required: true, message: '请选择上课时间', trigger: 'change'}],
      },
      typeArr:[{id:2,name:'大班课'},{id:4,name:'小班课'}],
      detailList:{},
      teacherList:{},
      timeArr:[],
    }
  },
  created(){
    this.id = this.$route.params && this.$route.params.id //课程ID
    this.group = this.$route.query.group
    this.template = this.$route.query.template
    this.name = this.$route.query.name
    let inforParams = {
      gc_id:this.id
    }
    this.getInfor(inforParams)
    let teacherparams = {
      realname:'',
      phone:''
    }
    this.obtainTeacher(teacherparams)
  },
  mounted(){

  },
  methods:{
    getInfor(params){
      this.$api.user.detailRelatedCourses(params)
      .then(res=>{
        if(res.code === 0){
          this.detailList = res.result
          let data = new Date()
          let year = data.getFullYear()
          let month = data.getMonth()
          let date = data.getDate()
          let begin_time = year +'-'+ month  +'-'+ +date +' ' +this.detailList.begin_time
          let end_time = year +'-'+ month  +'-'+ +date + ' ' +this.detailList.end_time
          this.timeArr.push(new Date(begin_time))
          this.timeArr.push(new Date(end_time))
        }
      }) 
    },
    obtainTeacher(params){
      this.$api.user.lecturerSelectList(params)
      .then(res=>{
        if(res.code === 0){
          this.teacherList = res.result
        }
      }) 
    },
    changeTime(val){
      this.detailList.begin_time=(val[0].getHours()>=10?val[0].getHours():'0'+val[0].getHours()) + ":" + (val[0].getMinutes()>=10?val[0].getMinutes():'0'+val[0].getMinutes())
      this.detailList.end_time=(val[1].getHours()>=10?val[1].getHours():'0'+val[1].getHours()) + ":" + (val[1].getMinutes()>=10?val[1].getMinutes():'0'+val[1].getMinutes())
    },
    onSubmit(){
      let params = {
        gc_id: this.id,
        teacher_id: this.detailList.teacher_id,
        date: this.detailList.date,
        begin_time: this.detailList.begin_time,
        end_time: this.detailList.end_time,
        max_users:this.detailList.max_users,
        pre_enter_time:Number(this.detailList.pre_enter_time)*60
      }
      this.$api.user.editRelatedCourses(params)
      .then(res=>{
        if(res.code === 0){
          this.$router.replace({
            path:'/class/course/' + this.group,
            query:{
              className:this.name
            }
          })
        }
      }) 
    },
  },
  watch:{
    
  },
}
</script>>
<style lang="scss" scoped>
  @import '../../../assets/scss/content.scss';
  @import '../../../assets/scss/relationClass.scss';
  
</style>
